<template>
  <Search />
</template>

<script>
import Search from '@/components/search/Search'
import { mapState } from 'vuex'

export default {
  name: 'SearchPage',
  components: { Search },
  computed: {
    ...mapState(['headline']),
  },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.headline,
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.headline,
          }),
        },
      ],
    }
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'searchresults',
    })
  },
}
</script>
